<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M5.15164 5.15162c.22503-.22496.5302-.35134.8484-.35134.31819 0 .62336.12638.8484.35134L12 10.3032l5.1516-5.15158c.1107-.11461.2431-.20603.3896-.26892.1464-.06289.3038-.09599.4632-.09738.1593-.00138.3173.02898.4648.08932.1475.06033.2814.14944.3941.26211.1127.11267.2018.24665.2621.39413.0604.14747.0907.30549.0893.46483-.0013.15933-.0344.31679-.0973.4632-.0629.1464-.1544.27882-.269.38951L13.6968 12l5.1516 5.1516c.2186.2263.3396.5295.3368.8441-.0027.3146-.1289.6156-.3514.8381-.2225.2225-.5234.3487-.8381.3514-.3146.0028-.6177-.1182-.8441-.3368L12 13.6968l-5.15156 5.1516c-.22633.2186-.52945.3396-.84408.3368-.31464-.0027-.61562-.1289-.83811-.3514-.22249-.2225-.34869-.5235-.35142-.8381-.00274-.3146.11822-.6178.33681-.8441L10.3032 12 5.15164 6.84842c-.22497-.22503-.35135-.5302-.35135-.8484 0-.31819.12638-.62336.35135-.8484Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M5.29289 5.29289c.39053-.39052 1.02369-.39052 1.41422 0L12 10.5858l5.2929-5.29291c.3905-.39052 1.0237-.39052 1.4142 0 .3905.39053.3905 1.02369 0 1.41422L13.4142 12l5.2929 5.2929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L12 13.4142l-5.29289 5.2929c-.39053.3905-1.02369.3905-1.41422 0-.39052-.3905-.39052-1.0237 0-1.4142L10.5858 12 5.29289 6.70711c-.39052-.39053-.39052-1.02369 0-1.41422Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
